module.exports = __webpack_public_path__ + "static/media/villum-logo.aa2d4606.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/forside/villum-logo.jpg
// module id = 1476
// module chunks = 0